import React, { useEffect, useState } from 'react'
import lottie from 'lottie-web/build/player/lottie_light'
import { Transition } from 'react-transition-group'

import loading from 'assets/loading'
import { FadeOut, useAnimationState } from 'libs/web-client/ui/animation'
import useStyles from './styles'

interface LoaderProps {
    isLoading: boolean
}

const Loader: React.FC<LoaderProps> = ({ isLoading }) => {
    const classes = useStyles()
    const { nodeRef } = useAnimationState(0)
    const [isRendered, setIsRendered] = useState(true)

    useEffect(() => {
        lottie.loadAnimation({
            container: document.querySelector('#logo') as Element,
            animationData: loading,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet',
            },
        })
    }, [])

    useEffect(() => {
        let id
        if (!isLoading) {
            id = setTimeout(() => {
                setIsRendered(false)
            }, 300)
        }
        return () => clearTimeout(id)
    }, [isLoading])

    return isRendered ? (
        <Transition nodeRef={nodeRef} in={!isLoading} timeout={0}>
            {state => (
                <FadeOut state={state}>
                    <div className={classes.loaderWrapper}>
                        <div id="logo" className={classes.loaderIcon} />
                    </div>
                </FadeOut>
            )}
        </Transition>
    ) : null
}

export default React.memo(Loader)
